export const APP_ROOT_URL = '/ai-create-store';
export const CATEGORIES_URL = '/';
export const INTRO_URL = '/intro';
export const TEMPLATE_SELECTION_URL = '/template';
export const STORE_NAME_URL = '/choose-store-name';
export const SITE_PREVIEW_URL = '/site-preview';
export const DOMAIN_URL = '/domain';
export const CHAT_URL = '/chat';
export const SETUP = '/setup';
export const CHECKOUT_URL = '/checkout';
